/* eslint-disable react/require-default-props */
import React from 'react';

import propTypes from 'prop-types';
import { Box } from '@mui/system';

import { CustomCard, Title, Subtitle, ChildrenContainer } from './styles';

export function ConfigCard({
  title,
  subtitle,
  children,
  justifyContent,
  alignItems,
  flexDirection,
  flexWrap,
  trallingIcon,
}) {
  return (
    <CustomCard>
      {title && <Title>{title}</Title>}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {trallingIcon}
        </>
      </Box>
      <ChildrenContainer
        justifyContent={justifyContent}
        alignItems={alignItems}
        flexDirection={flexDirection}
        flexWrap={flexWrap}
      >
        {children}
      </ChildrenContainer>
    </CustomCard>
  );
}

ConfigCard.propTypes = {
  title: propTypes.string.isRequired,
  subtitle: propTypes.string,
  children: propTypes.node,
  justifyContent: propTypes.string,
  alignItems: propTypes.string,
  flexDirection: propTypes.string,
};
